<template>
    <component :is="layout">
        <router-view />
        <GlobalSnackbar />
    </component>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from './layouts/DefaultLayout.vue'
import LoginLayout from './layouts/LoginLayout.vue'
import GlobalSnackbar from "./components/GlobalSnackbar.vue";

const route = useRoute()

const layout = computed(() =>
    route.meta.layout === 'login' ? LoginLayout : DefaultLayout
)
</script>
<style>
body {
    font-family: 'Inter', sans-serif;
}
</style>
